var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-if=\"!$ctrl.loading\" ng-include=\"$ctrl.timesContainerTpl\"></div>\n<div ng-if=\"$ctrl.loading\">\n<div class=\"spinner-wrapper\">\n<div us-spinner=\"{radius: 21, lines: 11, length: 13, width: 10}\"></div>\n<p class=\"text-center\" translate>Tietoja ladataan…</p>\n</div>\n</div>\n";
var id1="app/next-times/time-selection.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/next-times/time-selection.tpl.html
// module id = 453
// module chunks = 0